import React from "react";
import Box from "react-raster";
import styled from "styled-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import Container from "../Container";
import { H2, Copy, StyledList, Eyebrow, richTextOptions } from "../Typography";

const Description = styled.div`
  margin-bottom: 55px;
`;

function NoImage({
  eyebrow,
  title,
  description,
  capabilities,
  anchorId,
  removeHorizontalPadding,
  bottom = "100px",
  eyebrowColour,
  fullWidth = false,
}) {
  return (
    <Container
      id={anchorId}
      marginLeft={removeHorizontalPadding ? 0 : "30px"}
      marginBottom={bottom}
    >
      {fullWidth ? (
        <Box cols={[6, 12]}>
          {eyebrow && <Eyebrow colour={eyebrowColour}>{eyebrow}</Eyebrow>}
          <H2>{title}</H2>
          {description && (
            <Description>
              <Copy>{description}</Copy>
            </Description>
          )}
          {capabilities && (
            <StyledList>
              {renderRichText(capabilities, richTextOptions)}
            </StyledList>
          )}
        </Box>
      ) : (
        <>
          <Box cols={[6, 6]} marginRight={[0, 6]}>
            {eyebrow && <Eyebrow colour={eyebrowColour}>{eyebrow}</Eyebrow>}
            <H2>{title}</H2>
          </Box>
          <Box cols={[6, 6]}>
            {capabilities && (
              <StyledList>
                {renderRichText(capabilities, richTextOptions)}
              </StyledList>
            )}
          </Box>
          <Box cols={[6, 5]} marginLeft={[0, 1]}>
            {description && (
              <Description>
                <Copy>{description}</Copy>
              </Description>
            )}
          </Box>
        </>
      )}
    </Container>
  );
}

export default NoImage;
